import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import KnowAsServiceHeader from "../KnowAsServiceHeader";
import Images from "../../assets/Image";
import FilePdf from "../../broucherPdf/filePdf";
import ContactUsFooter from "../ContactUsFooter";
const BlogComp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showIcons, setShowIcons] = useState(false);

  const handleDownloadLaserBlog = () => {
    const link = document.createElement("a");
    link.href = FilePdf.usp_Laser_Blog;
    link.download = "USP_Laser_Blog.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (isOpen) {
      setShowIcons(true);
    } else {
      setShowIcons(false);
    }
  }, [isOpen]);

  return (
    <>
      <KnowAsServiceHeader content="BLOG" />
      <div className="blog_title_block">
        <p className="blog_title_content">
          The journey of a thousand miles begins with a single step Mr. Joseph
          established USP in the year 2005, with the objective of introducing
          technology-driven solutions in the packaging industry. Much like the
          packaging industry that has evolved with newer printers that offer
          better quality and cost-effectiveness, USP has grown steadily over the
          years to become a market leader today.
        </p>
      </div>
      {/* Intro section - simple paragraph block like title */}
      <div className="blog_title_block">
        <div style={{ width: "90%", textAlign: "center" }}>
          <h6 style={{ fontSize: "24px", fontWeight: "700", color: "#3185d2", marginBottom: "15px" }}>
            More Than Just a Mark: The Power of Laser Coding in Modern Packaging
          </h6>
          <p className="blog_title_content" style={{ fontStyle: "italic", marginBottom: "15px" }}>
            A practical guide to choosing the right laser marking technology for packaging that performs, protects, and promotes.
          </p>
          <p className="blog_title_content">
            Whether you're printing MFD, Use by/Best Before dates on a PET bottle or serial codes on a blister pack, your code has to be crisp, clear, indelible and authentic. In laser coding, permanence isn't just a feature, it's a promise. As we often say:
          </p>
          <p className="blog_title_content" style={{ fontWeight: "600", margin: "15px 0" }}>
            "Lasers don't just mark, they speak your brand's language."
          </p>
          <p className="blog_title_content">
            Therefore, how does one pick the right laser solution when every product, surface, and speed of your line demands something different?
          </p>
        </div>
      </div>
      {/* new continuation section added below title */}
      <div className="blog_content_main_block">
        <div className="blog_content_sub_block">
          <div className="blog_content_img_block">
            <img
              src={Images?.orangeIcon}
              alt="no-image"
              style={{ width: "100%", height: "100%" }}
            />
            <div className="blog_content_bottom">
              <div style={{ width: "40px", height: "40px" }}>
                <img
                  src={Images?.profileIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <p>
                <span className="blog_content_bottom_text">By Prasanth A</span>
                <br />
                <span className="blog_content_bottom_italic_text">
                  Oct 24, 2024
                </span>
              </p>
            </div>
          </div>
          <div className="blog_content_para_block">
            <h6 className="blog_content_para_heading">
              Why Choose Laser marking Over Inkjet Coding?
            </h6>
            <p className="blog_content_para">
              Think of laser coding like scribing with light. Instead of ink or ribbons, a laser beam changes the surface of your packaging with no contact, no smudging, and no consumables. That means:
            </p>
            <ul className="blog_content_list">
              <li>Permanent marks that won't fade or rub off</li>
              <li>Cleaner operations with no chemicals or messy ribbons…</li>
            </ul>
            <a 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                handleDownloadLaserBlog();
              }}
              className="blog_content_link_btn"
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              View Post
            </a>
          </div>
        </div>
      </div>
      {/* Original blog sections */}
      {/* para --1  */}
      <div className="blog_content_main_block">
        <div className="blog_content_sub_block">
          <div className="blog_content_img_block">
            <img
              src={Images?.orangeIcon}
              alt="no-image"
              style={{ width: "100%", height: "100%" }}
            />
            <div className="blog_content_bottom">
              <div style={{ width: "40px", height: "40px" }}>
                <img
                  src={Images?.profileIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <p>
                <span className="blog_content_bottom_text">By Prasanth A</span>
                <br />
                <span className="blog_content_bottom_italic_text">
                  Oct 24, 2024
                </span>
              </p>
            </div>
          </div>
          <div className="blog_content_para_block">
            <h6 className="blog_content_para_heading">Industrial Marking</h6>
            <p className="blog_content_para">
              Product marking gives sellers and buyers vital information on the
              characteristic nature of a given product or the packaging that
              contains it. These could be made by symbols, pictograms, graphics,
              logos, numbers or, as plain text. A product or its packaging will
              have to be marked in a way spelled out by specific guidelines
              stipulated …
            </p>
            <span className="blog_content_link_btn">View Post</span>
          </div>
        </div>
      </div>
      {/* para -->2 */}
      <div className="blog_content_main_block">
        <div className="blog_content_sub_block">
          <div className="blog_content_img_block">
            <img
              src={Images?.brucoffeeIcon}
              alt="no-image"
              style={{ width: "100%", height: "100%" }}
            />
            <div className="blog_content_bottom">
              <div style={{ width: "40px", height: "40px" }}>
                <img
                  src={Images?.profileIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <p>
                <span className="blog_content_bottom_text">By Prasanth A</span>
                <br />
                <span className="blog_content_bottom_italic_text">
                  Oct 24, 2024
                </span>
              </p>
            </div>
          </div>
          <div className="blog_content_para_block">
            <h6 className="blog_content_para_heading">Industrial Marking</h6>
            <p className="blog_content_para">
              Product marking gives sellers and buyers vital information on the
              characteristic nature of a given product or the packaging that
              contains it. These could be made by symbols, pictograms, graphics,
              logos, numbers or, as plain text. A product or its packaging will
              have to be marked in a way spelled out by specific guidelines
              stipulated …
            </p>
            <span className="blog_content_link_btn">View Post</span>
          </div>
        </div>
      </div>
      {/* para -->3 */}
      <div className="blog_content_main_block">
        <div className="blog_content_sub_block">
          <div className="blog_content_img_block">
            <img
              src={Images?.pipesIcon}
              alt="no-image"
              style={{ width: "100%", height: "100%" }}
            />
            <div className="blog_content_bottom">
              <div style={{ width: "40px", height: "40px" }}>
                <img
                  src={Images?.profileIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <p>
                <span className="blog_content_bottom_text">By Prasanth A</span>
                <br />
                <span className="blog_content_bottom_italic_text">
                  Oct 24, 2024
                </span>
              </p>
            </div>
          </div>
          <div className="blog_content_para_block">
            <h6 className="blog_content_para_heading">Industrial Marking</h6>
            <p className="blog_content_para">
              Product marking gives sellers and buyers vital information on the
              characteristic nature of a given product or the packaging that
              contains it. These could be made by symbols, pictograms, graphics,
              logos, numbers or, as plain text. A product or its packaging will
              have to be marked in a way spelled out by specific guidelines
              stipulated …
            </p>
            <span className="blog_content_link_btn">View Post</span>
          </div>
        </div>
      </div>

      {/* para -->4 */}
      <div className="blog_content_main_block">
        <div className="blog_content_sub_block">
          <div className="blog_content_img_block">
            <img
              src={Images?.aluminiumIcon}
              alt="no-image"
              style={{ width: "100%", height: "100%" }}
            />

            <div className="blog_content_bottom">
              <div style={{ width: "40px", height: "40px" }}>
                <img
                  src={Images?.profileIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <p>
                <span className="blog_content_bottom_text">By Prasanth A</span>
                <br />
                <span className="blog_content_bottom_italic_text">
                  Oct 24, 2024
                </span>
              </p>
            </div>
          </div>
          <div className="blog_content_para_block">
            <h6 className="blog_content_para_heading">Industrial Marking</h6>
            <p className="blog_content_para">
              Product marking gives sellers and buyers vital information on the
              characteristic nature of a given product or the packaging that
              contains it. These could be made by symbols, pictograms, graphics,
              logos, numbers or, as plain text. A product or its packaging will
              have to be marked in a way spelled out by specific guidelines
              stipulated …
            </p>
            <span className="blog_content_link_btn">View Post</span>
          </div>
        </div>
      </div>

      <ContactUsFooter />
      {/* Para -->4 */}

    </>
  );
};

export default BlogComp;


